import { useEffect } from 'react';

type StyledFromContainerProps = {
  children: React.ReactNode;
  title?: string;
};
export const StyledLoginFormContainer: React.FC<StyledFromContainerProps> = (props) => {
  //このコンポーネントを使用しているときはbodyにlogin-themeというクラスを追加する
  useEffect(() => {
    document.body.classList.add('login-theme');
    return () => document.body.classList.remove('login-theme');
  }, []);

  return (
    <main
      className="flex flex-col items-center justify-center w-full h-full overflow-x-hidden"
      style={{ background: 'var(--c-background)', height: '100vh' }}
    >
      <div className="w-[400px] flex flex-col items-center mb-20">
        <img
          src="logo_spotu_wt.png"
          alt="logo"
          title="logo"
          aria-label="logo"
          style={{ width: '350px', height: 'auto', marginBottom: '20px' }}
        />
        <p className="text-white font-bold m-2">{props.title}</p>
        {props.children}
      </div>
    </main>
  );
};
